<template>
  <v-flex xs12 mt-3 v-if="alternative">
    <v-card
      @click="flipCard"
      v-show="!showBack"
      class="animated black--text flipInX"
      color="white"
    >
      <div
        class="caption font-weight-bold grey--text text--darken-1 text-xs-center topText"
      >
        Question
      </div>
      <v-card-title primary-title class="pt-5">
        <div>
          <span class="title font-weight-light" v-html="front"></span>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <Confidence v-if="!temp" :confidence="confidence" :small="false" />
      </v-card-actions>
      <div class="caption grey--text text--darken-1 text-xs-center tapToFlip">
        Tap to Flip!
      </div>
    </v-card>
    <v-flex
      @click="flipCard"
      v-show="showBack"
      class="animated black--text flipInX"
      color="white"
    >
      <Alternative
        :temp="temp"
        :showText="true"
        :alternative="alternative"
        :parentId="card.id"
      />
    </v-flex>
  </v-flex>
  <SuggestAlternative v-else :card="card" />
</template>

<script>
import Alternative from "../components/Alternative";
import Confidence from "../components/Confidence";
import SuggestAlternative from "../components/SuggestAlternative";
import markdown from "markdown-it";
const md = markdown();

export default {
  components: {
    Alternative,
    Confidence,
    SuggestAlternative
  },
  props: ["card", "alternative", "confidence", "temp"],
  data: () => ({
    showBack: false
  }),
  watch: {
    front() {
      this.showBack = false;
    }
  },
  computed: {
    front() {
      return md.render(this.card.front);
    }
  },
  methods: {
    flipCard: function() {
      this.showBack = !this.showBack;
    }
  }
};
</script>

<style scoped>
.animated {
  animation-duration: 0.25s;
  animation-fill-mode: both;
}

@keyframes flipInX {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
  to {
    transform: perspective(400px);
  }
}

.flipInX {
  backface-visibility: visible !important;
  animation-name: flipInX;
}

.tapToFlip {
  position: fixed;
  bottom: 2px;
  width: 100%;
}

.topText {
  position: absolute;
  width: 100%;
}
</style>
